// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const beedrill_mega: PokeData = {
  "id": 10090,
  "name": "beedrill-mega",
  "height": 14,
  "weight": 405,
  "base_experience": 223,
  "types": [
    PokeType.BUG,
    PokeType.POISON
  ],
  "api_moves": [
    "fury-attack",
    "twineedle",
    "pin-missile",
    "peck",
    "agility",
    "rage",
    "focus-energy",
    "outrage",
    "pursuit",
    "endeavor",
    "assurance",
    "toxic-spikes",
    "poison-jab",
    "venoshock",
    "fell-stinger"
  ],
  "moves": [
    "pin-missile",
    "peck",
    "outrage",
    "pursuit",
    "toxic-spikes",
    "poison-jab",
    "acid-rain",
    "pounce",
    "poison-fang",
    "stun-spore",
    "acid",
    "bug-buzz",
    "sludge-bomb"
  ],
  "evolution_chain": {
    "id": 5,
    "item": null,
    "species": [
      {
        "name": "weedle",
        "order": 13,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kakuna",
        "order": 14,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 13,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 7,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "beedrill",
        "order": 15,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 14,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 70,
    "speed": 162,
    "ability_power": 168
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
